/**
 * Lite YouTube helpers.
 */

/**
 * Play embedded YT video.
 *
 * @param {Node} videoNode
 */
export const playVideo = async ( videoNode ) => {
	const player = await videoNode.getYTPlayer();

	if ( player ) {
		player.playVideo();
	}
};

/**
 * Pause embedded YT video.
 *
 * @param {Node} videoNode
 */
export const pauseVideo = async ( videoNode ) => {
	const player = await videoNode.getYTPlayer();

	if ( player ) {
		player.pauseVideo();
	}
};
